var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultprofile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#C32A7C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1173_324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 1.00049C8.83603 1.00049 1 8.83498 1 18.4997C1 28.1645 8.83526 35.9989 18.5 35.9989C28.1655 35.9989 36 28.1645 36 18.4997C36 8.83498 28.1655 1.00049 18.5 1.00049ZM18.5 6.23296C21.6978 6.23296 24.289 8.82498 24.289 12.0212C24.289 15.2182 21.6978 17.8094 18.5 17.8094C15.3038 17.8094 12.7125 15.2182 12.7125 12.0212C12.7125 8.82498 15.3038 6.23296 18.5 6.23296ZM18.4962 31.4237C15.3069 31.4237 12.3858 30.2622 10.1328 28.3397C9.58396 27.8716 9.26726 27.1851 9.26726 26.4649C9.26726 23.2233 11.8908 20.629 15.1331 20.629H21.8684C25.1115 20.629 27.725 23.2233 27.725 26.4649C27.725 27.1859 27.4099 27.8708 26.8603 28.339C24.608 30.2622 21.6862 31.4237 18.4962 31.4237Z",
    fill: "#EFEFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1173_324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultprofile);
export default __webpack_public_path__ + "static/media/defaultprofile.eb8d3396d9a376d7d58791524098e6de.svg";
export { ForwardRef as ReactComponent };